export default {
  getSelectedCity: (state) => state.cityLocation,
  getMeta: (state) => state.meta,
  getTitle: (state) => state.title
}
